<template>
    <div class="page-container">
        <el-card shadow="never" class="main-card">
            <!-- 查询条件区 + 操作按钮 -->
            <div class="search-bar">
                <el-input v-model="queryCon.supplierName" placeholder="供应商名称" style="width: 200px" />
                <el-button-group>
                    <el-button type="primary" :icon="Search" @click="handler.queryHandler">查询</el-button>
                    <el-button :icon="RefreshRight" @click="queryCon.supplierName=''">重置</el-button>
                </el-button-group>
                <div class="action-bar">
                    <el-button type="primary" plain :icon="CirclePlusFilled" @click="handler.addHandler">新增</el-button>
                    <el-button type="danger" plain :icon="Delete" @click="handler.deleteBatchHandler">删除</el-button>
                </div>
            </div>

            <!-- 表格区 -->
            <div class="table-wrapper">
                <el-table :data="tableData" v-loading="tableLoading" height="100%" row-key="id" class="modern-table"
                    :header-cell-style="{ background: '#fafafa', color: '#909399', fontWeight: 500 }" ref="dataTableRef">
        <el-table-column type="selection" width="40" />
        <el-table-column prop="supplierName" label="供应商名称" width="200"/>
        <el-table-column prop="supplierAddress" label="地址" />
        <el-table-column prop="supplierContacts" label="联系人" width="120" />
        <el-table-column prop="supplierTel" label="联系电话" width="120" />
        <el-table-column prop="remark" label="备注" width="120"/>
        <el-table-column prop="modifyName" label="修改人" width="100" />
        <el-table-column prop="modifyDate" label="修改日期" width="180">
            <template #default="scope">
                <span>{{ utils.formatDate(scope.row.modifyDate, "YYYY-MM-DD HH:mm:ss") }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="110" header-align="center" fixed="right">
            <template #default="scope">
                <el-button size="small" circle :icon="Edit" @click="handler.editHandler(scope.row)" />
                <el-button size="small" circle type="danger" :icon="Delete" @click="handler.deleteHandler(scope.row)" />
            </template>
        </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination background v-model:current-page="queryCon.currentPage" v-model:page-size="queryCon.pageSize"
                    :page-sizes="pagination.pageInfo.pageSizes" layout="total, sizes, prev, pager, next"
                    :total="pagination.pageInfo.total" @size-change="pagination.handleSizeChange"
                    @current-change="pagination.handleCurrentChange" />
            </div>
        </el-card>

    <el-dialog v-model="dialogFormVisible" title="新建/编辑" width="800">
        <el-form :inline="true" :model="form" :label-position="top" label-width="auto" :rules="rules" status-icon
            ref="dataFormRef">
            <el-form-item v-show="false" label="id" prop="id">
                <el-input v-model="form.id"></el-input>
            </el-form-item>
            <el-form-item label="供应商名称" prop="supplierName">
                <el-input v-model="form.supplierName" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="联系地址" prop="supplierAddress">
                <el-input v-model="form.supplierAddress" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="联系人" prop="supplierContacts">
                <el-input v-model="form.supplierContacts" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="联系电话" prop="supplierTel">
                <el-input v-model="form.supplierTel" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" autocomplete="off" class="el-input-width" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="handler.saveHandler">保存</el-button>
            </div>
        </template>
    </el-dialog>
    </div>
</template>

<style lang="css" scoped>
@import '../../../src/assets/styles/common.css';
</style>

<script setup>
import { nextTick,ref, reactive, onMounted } from 'vue';
import { ElTable, ElMessageBox, ElMessage } from 'element-plus';
import { Delete, CirclePlusFilled, Search, Edit, RefreshRight } from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
import "@/assets/styles/crud-page.css";
import utils from "@/utils/utils";
import sprintf from 'sprintf-js';
import {supplierApi} from "@/api/supplierApi.js";


//查询条件
const queryCon = reactive({ supplierName: '', pageSize: 10, currentPage: 1  })

//分页处理
const pagination = {
    pageInfo: reactive({
        total: 0,
        pageSizes: [10, 20, 30, 50, 100]
    }),
    handleSizeChange: (val) => {
        queryCon.pageSize = val;
        handler.queryHandler();
    },
    handleCurrentChange: (val) => {
        queryCon.currentPage = val;
        handler.queryHandler();
    }
}

//表单对象
const form = reactive({
    id: '',
    supplierName: '',
    supplierAddress: '',
    supplierContacts: '',
    supplierTel:'',
    remark: ''
})


const rules = {
    supplierName: [
        { required: true, message: '', trigger: 'blur' }
    ],
    supplierAddress: [
        { required: true, message: '', trigger: 'blur' }
    ],
    supplierContacts:[
        { required: true, message: '', trigger: 'blur' }
    ],
    supplierTel: [
        { required: true, message: '', trigger: 'blur' }
    ]
};

//弹出框状态
const dialogFormVisible = ref(false);
const tableLoading = ref(false);
const tableData = ref([]);
//引用
const dataTableRef = ref(null);
const dataFormRef = ref(null);

//生命周期
onMounted(() => {
    handler.queryHandler();
});

const resetForm = () => {
    dataFormRef.value?.resetFields();
};


//UI界面逻辑
const handler = {
    queryHandler(){
        tableLoading.value = true;
        supplierApi.query(queryCon).then((response) => {
            if (response.data.errorCode === "00000") {
                tableData.value = response.data.result.records;
                pagination.pageInfo.total = response.data.result.total;
            }else{
                ElMessage.error(sprintf("系统异常[ ErrorCode:%s ]", response.data.errorCode));
            }
        })
        .finally(function () {
            tableLoading.value = false;
        });
    },
    addHandler(){
        resetForm();
        dialogFormVisible.value = true;
    },
    editHandler(rowObj){
        resetForm();
        dialogFormVisible.value = true;
        nextTick(()=>{
            Object.assign(form, rowObj);
        })
    },
    deleteHandler(rowObj){
        ElMessageBox.confirm(
            '确认要删除吗?',
            'Warning',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
        .then(() => {
            supplierApi.delete([rowObj.id])
                .then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '删除成功.', type: 'success' });
                        handler.queryHandler();
                        this.dialogFormVisible = false;
                    }else{
                        ElMessage.error(sprintf("系统异常[ ErrorCode:%s ]", response.data.errorCode));
                    }
                })
        })
    },
    deleteBatchHandler(){
        var selectedRows = dataTableRef.value.getSelectionRows();
        if(selectedRows && selectedRows.length == 0){ ElMessage("没有选中任何行");return;}

        var ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        ElMessageBox.confirm(
            '确认要删除吗?',
            'Warning',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
        .then(() => {
            supplierApi.delete(ids)
                .then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '删除成功.', type: 'success' });
                        handler.queryHandler();
                        this.dialogFormVisible = false;
                    }else{
                        ElMessage.error(sprintf("系统异常[ ErrorCode:%s ]", response.data.errorCode));
                    }
                })
        })
    },
    saveHandler(){
        dataFormRef.value.validate((valid) => {
            if (valid) {
                supplierApi.save(form).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '保存成功', type: 'success' });
                        handler.queryHandler();
                        dialogFormVisible.value = false;
                    }else{
                        ElMessage.error("系统出错[errorCode:"+response.data.errorCode+"]");
                    }
                })
            }
        });
    }
}
</script>